import React from 'react'
import PrivacyPolicy from './PrivacyPolicy'
import PrivacyHero from './PrivacyHero'

const PrivacyPolicyPage = () => {
  return (
    <>
          <PrivacyHero/>
          <PrivacyPolicy/>
      </>
  )
}

export default PrivacyPolicyPage